import { render, staticRenderFns } from "./CompContestsGridContainer.vue?vue&type=template&id=43d09493&scoped=true"
import script from "./CompContestsGridContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./CompContestsGridContainer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d09493",
  null
  
)

export default component.exports